/**
 * Vim keybindings toggle — mirrors `InterfaceThemeToggle.tsx`'s shape
 * exactly: self-contained (App.tsx never needs to know this exists, it
 * never affects the diagram or travels in share.ts's payload), subscribes
 * to `vimMode.ts`'s tiny store rather than owning state locally so this
 * button and the command palette's equivalent entry never go out of sync.
 */
import { Keyboard } from 'lucide-react';
import { useEffect, useState } from 'react';
import { getVimMode, subscribeVimMode, toggleVimMode } from '../lib/vimMode';

export default function VimModeToggle() {
  const [enabled, setEnabled] = useState(getVimMode);

  useEffect(() => subscribeVimMode(setEnabled), []);

  return (
    <button
      type="button"
      onClick={toggleVimMode}
      aria-pressed={enabled}
      aria-label={enabled ? 'Turn off vim keybindings' : 'Turn on vim keybindings'}
      title="Vim keybindings"
      className={`flex items-center rounded-sm p-1.5 hover:bg-ink-3 ${enabled ? 'text-pink' : 'text-text-ink'}`}
    >
      <Keyboard size={14} aria-hidden />
    </button>
  );
}
